module.exports = __webpack_public_path__ + "static/media/order2.9ea381a0.png";